import { globalStores } from '@/editor/stores';
import { EEntityType } from '@/editor/types';
import { IIntersectedModelEntityInfo } from '@/editor/types/entity';
import { showToast } from '@/editor/utils/feedback';
import i18next from '@/i18n';

/**
 * 自动布局下当前实体是否允许被 hover
 */
export const isHoverAllowed = (
  intersectedEntity: IIntersectedModelEntityInfo | null
): intersectedEntity is IIntersectedModelEntityInfo => {
  if (!intersectedEntity) {
    return false;
  }

  const { autoLayoutModeData } = globalStores.editorStateStore;

  if (intersectedEntity.type === EEntityType.Room) {
    const isValid = autoLayoutModeData.allowedRoomIds.includes(intersectedEntity.entityId);
    return isValid;
  }
  if (intersectedEntity.type === EEntityType.DoorWindow) {
    const isValid = autoLayoutModeData.allowedDoorIds.includes(intersectedEntity.entityId);
    return isValid;
  }

  return false;
};

/**
 * 自动布局下当前实体是否允许被选中
 */
export const isSelectAllowed = (
  intersectedEntity: IIntersectedModelEntityInfo | null
): intersectedEntity is IIntersectedModelEntityInfo => {
  if (!intersectedEntity) {
    return false;
  }

  const { autoLayoutModeData } = globalStores.editorStateStore;

  const isAllowedByAutoMode = [EEntityType.Room, EEntityType.DoorWindow].includes(intersectedEntity.type);

  if (!isAllowedByAutoMode) {
    return false;
  }

  const isValidDoor = autoLayoutModeData.allowedDoorIds.includes(intersectedEntity.entityId);

  const isValidRoom = autoLayoutModeData.allowedRoomIds.includes(intersectedEntity.entityId);

  if (intersectedEntity.entityId && autoLayoutModeData.disabledRoomIds.includes(intersectedEntity.entityId)) {
    toastNoDoorInRoom();
  }

  return isValidRoom || isValidDoor;
};

export const toastNoDoorInRoom = () => {
  showToast(i18next.t('draw.layout.tool.noDoor'));
};
